/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../ui/Button";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import { updateEvent } from "../../../firebaseFunctions/updateEOEvent";

const Faq = ({ eventData, reload }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id: eventId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [faqs, setFaqs] = useState([{ question: "", answer: "" }])

    const handleNewFAQInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedFaqList = [...faqs];
        updatedFaqList[index][name] = value;
        setFaqs(updatedFaqList);
    };
    // Add new FAQ
    const addNewFAQ = () => {
        setFaqs((prev) => [
            ...prev,
            { question: "", answer: "" }
        ]);
    };
    const handleSaveChanges = async () => {
        setIsLoading(true);
        try {
            const newFAQs = [...(eventData?.faqList || []), ...faqs];
            const updatedEventData = {
                faqList: newFAQs,
                eventId: eventId,
            };

            const result = await updateEvent(updatedEventData);

            if (result.success) {
                reload()
                setFaqs([{ question: "", answer: "" }])
                setIsLoading(false);
            } else {
                setFaqs([{ question: "", answer: "" }])
                setIsLoading(false)
            }
        } catch (error) {
            console.error("Error while saving changes:", error);
        }
    };

    if (isLoading) return <ModalLoadingState />
    return (
        <>
            <div className="w-full p-6">
                <p className="mb-7 pl-1 pr-1 sm:pr-8 sm:pl-8 text-xl font-medium text-grey-900">
                    {t('eventDetails.frequentlyAskedQuestions')}
                </p>
                <div className="flex flex-col space-y-6 rounded-2xl pl-1 pr-1 sm:pr-8 sm:pl-8 max-w-[70%]">
                    {eventData?.faqList &&
                        eventData.faqList.some(
                            (faq) => faq.question.trim() !== "" && faq.answer.trim() !== ""
                        ) ? (
                        eventData.faqList.map((faq, index) => (
                            <div key={index} className="space-y-2">
                                <div className="space-y-1">
                                    <p className="text-grey-900 mb-2 leading-relaxed">
                                        {faq.question}
                                    </p>
                                    <p className="text-grey-600 mb-2 leading-relaxed">
                                        {faq.answer}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-grey-600">{t('eventDetails.noFaqsAvailable')}</p>
                    )}
                </div>

                <div className="space-y-4 mx-4 w-full lg:w-1/2">
                    <div className="space-y-2 mt-8">
                        <label className="block text-md font-medium text-grey-900">
                            {t('eventDetails.addMoreFaqs')}
                        </label>
                    </div>
                    {faqs.map((faq, index) => (
                        <div key={index} className="mb-4">
                            <label className="block text-sm font-medium text-grey-900 mb-2">
                                {t('eventDetails.enterQuestion')}
                            </label>
                            <input
                                type="text"
                                name="question"
                                value={faq.question}
                                onChange={(event) => handleNewFAQInputChange(index, event)}
                                placeholder={t('eventDetails.enterQuestionPlaceholder')}
                                className="w-full p-2 border border-grey-300 rounded-lg mb-4"
                            />

                            <label className="block text-sm font-medium text-grey-900 mb-2">
                                {t('eventDetails.enterAnswer')}
                            </label>
                            <textarea
                                name="answer"
                                rows={4}
                                value={faq.answer}
                                onChange={(event) => handleNewFAQInputChange(index, event)}
                                placeholder={t('eventDetails.enterAnswerPlaceholder')}
                                className="w-full p-2 border border-grey-300 rounded-lg"
                            />
                        </div>
                    ))}

                    <button
                        onClick={addNewFAQ}
                        className="mt-2 flex items-center text-sm font-medium text-grey-900 underline underline-offset-4"
                    >
                        {t('eventDetails.addAnotherFaq')}
                    </button>
                </div>
                <div className="flex justify-end mt-8">
                    <Button onClick={handleSaveChanges}>
                        {t('eventDetails.saveChanges')}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default Faq;
